export const extractFinancialIntermediaryDetails = (): {
  isFinancialIntermediary: boolean;
  country: string;
  language: string;
} => {
  const path = window.location.pathname;
  const previewMatch = path.match(
    /^\/products\/preview\/([a-z]{2})\/([a-z]{2})\/financial-intermediary/,
  );
  const nonPreviewMatch = path.match(
    /^\/financial-intermediary\/([a-z]{2})\/([a-z]{2})/,
  );
  if (previewMatch) {
    return {
      isFinancialIntermediary: true,
      language: previewMatch[1],
      country: previewMatch[2],
    };
  }
  if (nonPreviewMatch) {
    return {
      isFinancialIntermediary: true,
      country: nonPreviewMatch[1],
      language: nonPreviewMatch[2],
    };
  }
  return {
    isFinancialIntermediary: false,
    country: '',
    language: '',
  };
};
